import { render, staticRenderFns } from "./ApplicationForm.vue?vue&type=template&id=ff85f9fe&scoped=true"
import script from "./ApplicationForm.vue?vue&type=script&lang=ts"
export * from "./ApplicationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff85f9fe",
  null
  
)

export default component.exports